export const MainApiUrl = process.env.REACT_APP_BACKEND_URL;
